var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartWarningLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 56.12c14.088 0 25.509-11.421 25.509-25.51 0-14.087-11.42-25.508-25.509-25.508-14.088 0-25.509 11.42-25.509 25.509 0 14.088 11.42 25.509 25.51 25.509zM31 40.814V30.611M31 20.407h.026",
    stroke: "#E95832",
    strokeWidth: 5.102,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/cartWarningLogo.88d6c122.svg";
export { SvgCartWarningLogo as ReactComponent };